import { NicknameValidator } from "@/utils/NicknameValidator";
import { RequestHandler } from "../base/RequestHandler";
import { prompt } from "./../../Control/Vue/Notifications/Prompts";

export class Name extends RequestHandler {
	private readonly closeBtn: JQuery;
	private readonly submitBtn: JQuery;

	constructor(element: JQuery) {
		super(element);
		this.submitBtn = this.element.find(".mia-submit");
		this.submitBtn.on("click", (event) => void this.onSubmitClick(event));

		this.closeBtn = this.element.find(".close");
	}

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	protected onFail(res: any) {
		this.closeBtn.click();
		super.onFail(res);
	}

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	protected onDone(res: any) {
		if (res.msg) {
			prompt(res.msg);
		}
		this.closeBtn.click();
		super.onDone(res);
	}

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	protected onSuccess(_res: any) {
		this.closeBtn.click();
		location.reload();
	}

	private async onSubmitClick(event: JQuery.Event): Promise<void> {
		event.preventDefault();
		const writtenNickname = this.element.find("input.mia-nickname").val() ?? "";

		if (!NicknameValidator.isNicknameValid(writtenNickname.toString())) {
			prompt(this.element.data("nickname-invalid"));
			return;
		}

		await this.sendRequest(this.submitBtn.data("url"), { nickname: writtenNickname });
	}
}
